import * as XLSX from 'xlsx';
import { InvestigadorRecord } from '../types';

export const downloadExcel = (records: InvestigadorRecord[]): void => {
  const rows: Record<string, string>[] = [];

  records.forEach((record) => {
    const detalleCargo = (() => {
      if (record.cargo === 'Docente') {
        const parts: string[] = [];
        if (record.carreraDocente) parts.push(`Carrera: ${record.carreraDocente}`);
        if (record.materiaDocente) parts.push(`Materias: ${record.materiaDocente}`);
        return parts.join(' | ');
      }
      if (record.cargo === 'Administrativo') return record.cargoAdminDetalle ? `Cargo: ${record.cargoAdminDetalle}` : '';
      if (record.cargo === 'Estudiante') {
        const parts = [record.carreraEstudiante, record.nivelEstudiante].filter(Boolean);
        return parts.length ? `Carrera: ${parts.join(' — ')}` : '';
      }
      return '';
    })();

    const baseRow = {
      'Fecha de Registro': record.fechaRegistro,
      Nombre: record.nombre,
      Apellido: record.apellido,
      'Correo Electrónico': record.email,
      Teléfono: record.telefono,
      ORCID: record.orcid || '',
      'Profesión': record.unidad,
      'Postgrado': record.postgrado || '',
      'Tipo de Usuario': record.tipoUsuario === 'docente' ? 'Docente' : 'Estudiante',
      'Cargo en la Universidad': record.cargo,
      'Carrera (Docente)': record.carreraDocente || '',
      'Materia(s) que imparte': record.cargo === 'Docente' ? record.materiaDocente || '' : '',
      'Detalle del Cargo': detalleCargo,
    };

    if (record.publicaciones.length === 0) {
      rows.push({ ...baseRow, 'Título de Publicación': '', 'Base de Datos': '', 'Enlace / Archivo': '' });
    } else {
      record.publicaciones.forEach((pub, idx) => {
        const baseDatosLabel =
          pub.baseDatos === 'Otras (especificar)' && pub.baseDatosOtra
            ? `Otras: ${pub.baseDatosOtra}`
            : pub.baseDatos || 'Sin especificar';

        const enlaceLabel = pub.archivoNombre
          ? `Archivo adjunto: ${pub.archivoNombre}`
          : pub.link || '';

        const personRow = idx === 0 ? baseRow : Object.fromEntries(Object.keys(baseRow).map((k) => [k, '']));

        rows.push({
          ...personRow,
          'Título de Publicación': pub.titulo,
          'Base de Datos': baseDatosLabel,
          'Enlace / Archivo': enlaceLabel,
        });
      });
    }
  });

  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Investigadores UPAL');

  worksheet['!cols'] = [
    { wch: 22 }, // Fecha
    { wch: 20 }, // Nombre
    { wch: 20 }, // Apellido
    { wch: 32 }, // Email
    { wch: 16 }, // Teléfono
    { wch: 40 }, // ORCID
    { wch: 28 }, // Unidad
    { wch: 14 }, // Tipo
    { wch: 36 }, // Profesión/Título
    { wch: 18 }, // Cargo
    { wch: 40 }, // Detalle cargo
    { wch: 48 }, // Título pub
    { wch: 28 }, // Base datos
    { wch: 52 }, // Enlace
  ];

  const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([wbout], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const date = new Date().toISOString().split('T')[0];
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `censo_investigadores_upal_${date}.xlsx`;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
};